import { ILabSubscriber } from 'interfaces';
import { BaseService } from './BaseService';

type LabSubscriberEntity = ILabSubscriber & { id: number };

class LabSubscriberService extends BaseService<LabSubscriberEntity> {
  constructor() {
    super('lab-subscribers');
  }

  canDelete = true;
}

export const labSubscriberService = new LabSubscriberService();
